export default "__VITE_ASSET__BN91r6P2__"